module.exports = __webpack_public_path__ + "static/media/help.e38c4050.svg";